import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function About() {
  return (
    <div className="overflow-hidden">
      <div className="container-fluid py-5">
        <div className="container">
          <div className="row align-items-center">
            <motion.div 
              className="col-lg-5"
              initial={{ opacity: 0, x: -100 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
            >
              <img
                className="img-fluid rounded mb-5 mb-lg-0"
                src={require("../assets/about.jpg")}
                alt=""
              />
            </motion.div>
            <motion.div 
              className="col-lg-7"
              initial={{ opacity: 0, x: 100 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
            >
              <p className="section-title pr-5">
                <span className="pr-2">Learn About Us</span>
              </p>
              <h1 className="mb-4">Best School For Your Kids</h1>
              <p>
                We help you to build your child's future! The educational
                programs of our school will give your child all the necessary
                skills and knowledge to make everything they learned here work
                for them in the future.
              </p>
              <div className="row pt-2 pb-4">
                <div className="col-12 col-md-8">
                  <ul className="list-inline m-0">
                    <motion.li 
                      className="py-2 border-top border-bottom"
                      initial={{ opacity: 0, y: 10 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ delay: 0.5 }}
                    >
                      <i className="fa fa-check text-primary mr-3" />
                      Academic Excellence
                    </motion.li>
                    <motion.li 
                      className="py-2 border-bottom"
                      initial={{ opacity: 0, y: 10 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ delay: 0.6 }}
                    >
                      <i className="fa fa-check text-primary mr-3" />
                      Community and Outdoor Education
                    </motion.li>
                    <motion.li 
                      className="py-2 border-bottom"
                      initial={{ opacity: 0, y: 10 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ delay: 0.7 }}
                    >
                      <i className="fa fa-check text-primary mr-3" />
                      International Understanding
                    </motion.li>
                  </ul>
                </div>
              </div>
              <Link to="/about" className="btn btn-primary mt-2 py-2 px-4">
                Learn More
              </Link>
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
}
